import React from 'react';

export default class HeaderMobileMenuItem extends React.Component {
  static propTypes = {
    children: React.PropTypes.node,
    isActive: React.PropTypes.bool,
    iconText: React.PropTypes.string,
    type:     React.PropTypes.string,
    title:    React.PropTypes.string,
    onClick:  React.PropTypes.func
  };

  renderIcon = () => {
    if (this.props.isActive) {
      return <i className="menuitem__header__icon--minus" />;
    }
    else {
      return <i className="menuitem__header__icon--plus" />;
    }
  };

  renderPanel = () => {
    if (this.props.isActive) {
      return <div className="menuitem__content">{this.props.children}</div>;
    }
  };

  renderIconText = () => {
    if (this.props.iconText) {
      return (
        <span className="menuitem__header--language__icontext">{this.props.iconText}</span>
      );
    }
  };

  render () {
    var className = this.props.type ? 'menuitem--' + this.props.type : 'menuitem';
    var headerClassName = this.props.type ? 'menuitem__header--' + this.props.type : 'menuitem__header';

    if (this.props.isActive) {
      className += ' is-active';
      headerClassName += ' is-active';
    }

    return (
      <li className={className}>
        <h3
          onClick={this.props.onClick}
          className={headerClassName}
          data-component={this.props.title.toLowerCase()}>
          {this.renderIconText()}{this.props.title} {this.renderIcon()}
        </h3>
        {this.renderPanel()}
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/mobile/menuitem/index.js